import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './modules/home/home.component';
import { ProfileComponent } from './modules/profile/profile.component';
import { NavBarComponent } from './core/components/nav-bar/nav-bar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './modules/login/login.component';
import {
  FacebookLoginProvider,
  SocialAuthServiceConfig,
  SocialLoginModule,
} from 'angularx-social-login';
import { BtnLifeDiComponent } from './shared/components/btn-life-di/btn-life-di.component';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { CookieService } from 'ngx-cookie-service';
import { ModalComponent } from './shared/components/modal/modal.component';
import { RegisterComponent } from './modules/register/register.component';
import { HttpClientModule } from '@angular/common/http';

// angular material UI
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxAudioPlayerModule } from 'ngx-audio-player';
import { PlyrModule } from 'ngx-plyr';
import { MatSliderModule } from '@angular/material/slider';
import { QRCodeModule } from 'angular2-qrcode';
import { CountdownModule } from 'ngx-countdown';
import { JwtModule, JwtHelperService, JWT_OPTIONS } from "@auth0/angular-jwt";

import { CarouselModule } from 'ngx-owl-carousel-o';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { CardBoxComponent } from './shared/components/card-box/card-box.component';
import { DatePipe, DateTimePipe, DateTimeAgoPipe } from './shared/pipe/date.pipe';
import { IconHomeComponent } from './shared/components/icon-home/icon-home.component';
import { BreadcrumbComponent } from './shared/components/breadcrumb/breadcrumb.component';
import { ChipsComponent } from './shared/components/chips/chips.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { UserManagementComponent } from './modules/user-management/user-management.component';
import { TableComponent } from './shared/components/table/table.component';
import { HistoryComponent } from './modules/user-management/history/history.component';
import { ModalAccountComponent } from './modules/user-management/modal-account.component';
import { ModalAddAccountComponent } from './modules/user-management/modal-add-account.component';
import { NewsUpdateComponent } from './modules/news-update-management/news-update.component';
import { ManageNewsComponent } from './modules/news-update-management/manage-news/manage-news.component';
import { ModalPreviewComponent } from './modules/news-update-management/manage-news/modal-preview.component';
import { AllNewsComponent } from './modules/all-news/all-news.component';
import { NewsComponent } from './modules/all-news/news/news.component';
import { ActivityManagementComponent } from './modules/activity-management/activity-management.component';
import { ConsultComponent } from './modules/activity-management/consult/consult.component';
import { WorkshopComponent } from './modules/activity-management/workshop/workshop.component';
import { ManageWorkshopComponent } from './modules/activity-management/workshop/manage-workshop/manage-workshop.component';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_LOCALE,
} from 'ng-pick-datetime';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzIconModule, NZ_ICONS } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzCardModule } from 'ng-zorro-antd/card';
import { SwiperModule } from 'swiper/angular';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';

import { IconDefinition } from '@ant-design/icons-angular';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { AllWorkshopComponent } from './modules/activity/workshop/all-workshop.component';
import { ActivityComponent } from './modules/activity/activity.component';
import { WorkshopDetailComponent } from './modules/activity/workshop/workshop-detail/workshop-detail.component';
import { LengthOfArrayPipe } from './shared/pipe/length-of-array.pipe';
import { ChangePasswordComponent } from './modules/profile/change-password/change-password.component';
import { PhoneNOPipe } from './shared/pipe/phone-no.pipe';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FlatpickrModule } from 'angularx-flatpickr';
import { ModalConsultComponent } from './modules/activity-management/consult/modal-consult/modal-consult.component';
import { AddConsultComponent } from './modules/activity-management/consult/manage-consult/add-consult/add-consult.component';
import { ManageConsultComponent } from './modules/activity-management/consult/manage-consult/manage-consult.component';
import { DuplicateConsultComponent } from './modules/activity-management/consult/manage-consult/duplicate-consult/duplicate-consult.component';
import { ConsultUserComponent } from './modules/activity/consult/consult-user.component';
import { RegisterConsultDialogComponent } from './modules/activity/consult/register-consult-dialog/register-consult-dialog.component';
import { AboutComponent } from './modules/about/about.component';
import { ELearningManagementComponent } from './modules/e-learning-management/e-learning-management.component';
import { ManageCourseComponent } from './modules/e-learning-management/manage-course/manage-course.component';
import { ModalAddTopicComponent } from './modules/e-learning-management/modal-add-topic/modal-add-topic.component';
import { ELearningComponent } from './modules/e-learning/e-learning.component';
import { CourseCardComponent } from './shared/components/course-card/course-card.component';
import { CourseComponent } from './modules/e-learning/course/course.component';
import { ModalQuizComponent } from './modules/e-learning/course/modal-quiz/modal-quiz.component';
import { ModalAssignmentComponent } from './modules/e-learning/course/modal-assignment/modal-assignment.component';
import { AssignmentComponent } from './modules/e-learning-management/assignment/assignment.component';
import { AssignmentManagementComponent } from './modules/e-learning-management/assignment-management/assignment-management.component';
import { ReviewManagementComponent } from './modules/e-learning-management/review-management/review-management.component';
import { ModalCertificateComponent } from './modules/e-learning/course/modal-certificate/modal-certificate.component';
import { SanitizeHtmlPipe } from './shared/pipe/sanitize-html.pipe';
import { UpgradePremiumComponent } from './modules/profile/upgrade-premium/upgrade-premium.component';
import { ModalAvatarComponent } from './modules/profile/modal-avatar/modal-avatar.component';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ArticalManagementComponent } from './modules/artical-management/artical-management.component';
import { ManageArticalComponent } from './modules/artical-management/manage-artical/manage-artical.component';
import { ArticalsComponent } from './modules/articals/articals.component';
import { ModalArticalPreviewComponent } from './modules/artical-management/modal-artical-preview/modal-artical-preview.component';
import { ModalArticalPollComponent } from './modules/artical-management/modal-artical-poll/modal-artical-poll.component';
import { ChartModule } from 'primeng/chart';
import { ArticalComponent } from './modules/articals/artical/artical.component';
import { UserHistoryComponent } from './modules/user-history/user-history.component';
import { ChatManagementComponent } from './modules/e-learning-management/chat-management/chat-management.component';
import { SearchComponent } from './modules/search/search.component';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { SkillTreeComponent } from './shared/components/skill-tree/skill-tree.component';
import { SkillTreeManagementComponent } from './modules/skill-tree-management/skill-tree-management.component';
import { ManageSkillTreeComponent } from './modules/skill-tree-management/manage-skill-tree/manage-skill-tree.component';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ModalSkillTreeComponent } from './modules/skill-tree-management/modal-skill-tree/modal-skill-tree.component';
import { SymbolSkillTreeComponent } from './shared/components/symbol-skill-tree/symbol-skill-tree.component';
import { SkillTreeByCourseComponent } from './modules/skill-tree-by-course/skill-tree-by-course.component';
import { PrivacyPolicyComponent } from './modules/privacy-policy/privacy-policy.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { PaymentComponent } from './modules/payment/payment.component';
import { TransferComponent } from './modules/payment/transfer/transfer.component';
import { PaymentManagementComponent } from './modules/payment-management/payment-management.component';
import { PaymentDetailComponent } from './modules/payment-management/payment-detail/payment-detail.component';
import { PaymentVerifyComponent } from './modules/payment-management/payment-verify/payment-verify.component';
import { ModalPaymentRejectComponent } from './modules/payment-management/modal-payment-reject/modal-payment-reject.component';
import { MeasureManagementComponent } from './modules/measure-management/measure-management.component';
import { ManageMeasureComponent } from './modules/measure-management/manage-measure/manage-measure.component';
import { ModalAddQuestionComponent } from './modules/measure-management/modal-add-question/modal-add-question.component';
import { QuestionMultipleChoiceComponent } from './shared/components/question-multiple-choice/question-multiple-choice.component';
import { QuestionMultiComponent } from './shared/components/question-multi/question-multi.component';
import { QuestionRatingComponent } from './shared/components/question-rating/question-rating.component';
import { QuestionRankingComponent } from './shared/components/question-ranking/question-ranking.component';
import { QuestionMostLeastComponent } from './shared/components/question-most-least/question-most-least.component';
import { MultipleChoiceComponent } from './shared/components/multiple-choice/multiple-choice.component';
import { RatingChoiceComponent } from './shared/components/rating-choice/rating-choice.component';
import { RankingChoiceComponent } from './shared/components/ranking-choice/ranking-choice.component';
import { MostLeastChoiceComponent } from './shared/components/most-least-choice/most-least-choice.component';
import { MeasureComponent } from './modules/measure/measure.component';
import { MeasureManagementDetailComponent } from './modules/measure-management/measure-management-detail/measure-management-detail.component';
import { MeasureStartComponent } from './modules/measure/measure-start/measure-start.component';
import { MeasureCardComponent } from './shared/components/measure-card/measure-card.component';
import { ModalShareComponent } from './shared/components/measure-card/modal-share/modal-share.component';
import { MeasureDetailComponent } from './modules/measure/measure-detail/measure-detail.component';
import { SymbolRequireComponent } from './shared/components/symbol-require/symbol-require.component';
import { ResearchManagementComponent } from './modules/research-management/research-management.component';
import { ManageResearchComponent } from './modules/research-management/manage-research/manage-research.component';
import { ModalMeasureReportComponent } from './modules/measure/modal-measure-report/modal-measure-report.component';
import { ResearchComponent } from './modules/research/research.component';
import { ResearchScreenQuestionComponent } from './modules/research/research-screen-question/research-screen-question.component';
import { ResearchMeasureComponent } from './modules/research/research-measure/research-measure.component';
import { ResearchCardComponent } from './shared/components/research-card/research-card.component';
import { ResearchConsentComponent } from './modules/research/research-consent/research-consent.component';
import { ResearchDetailComponent } from './modules/research/research-detail/research-detail.component';
import { ResearchChoiceComponent } from './shared/components/research-choice/research-choice.component';
import { ModalMeasureReportConsultComponent } from './modules/measure/modal-measure-report-consult/modal-measure-report-consult.component';
import { ReportManagementComponent } from './modules/report-management/report-management.component';
import { ManageReportComponent } from './modules/report-management/manage-report/manage-report.component';
import { ModalCalculateComponent } from './modules/report-management/modal-calculate/modal-calculate.component';
import { ReportTemplateComponent } from './modules/report-management/report-template/report-template.component';
import { TestReportComponent } from './modules/test-report/test-report.component';
import { ReportProfileComponent } from './shared/components/report-profile/report-profile.component';
import { ReportSpiderComponent } from './shared/components/report-spider/report-spider.component';
import { ReportStandardComponent } from './shared/components/report-standard/report-standard.component';
import { ReportBoxchartComponent } from './shared/components/report-boxchart/report-boxchart.component';
import { ReportMatchingComponent } from './shared/components/report-matching/report-matching.component';
import { ReportProfileTemplateComponent } from './shared/components/report-profile-template/report-profile-template.component';
import { ReportSpiderTemplateComponent } from './shared/components/report-spider-template/report-spider-template.component';
import { ReportFourBoxTemplateComponent } from './shared/components/report-four-box-template/report-four-box-template.component';
import { ReportProfileMatchingTemplateComponent } from './shared/components/report-profile-matching-template/report-profile-matching-template.component';
import { DashboardAdminComponent } from './modules/dashboard-admin/dashboard-admin.component';
import { FinancialListComponent } from './modules/financial-list/financial-list.component';
import { FinancialCategoryComponent } from './modules/financial-list/financial-category/financial-category.component';
import { ModalPaymentReportComponent } from './modules/payment-management/modal-payment-report/modal-payment-report.component';
import { ModalUploadSignatureComponent } from './modules/payment-management/modal-upload-signature/modal-upload-signature.component';
import { PaymentSuccessComponent } from './modules/payment/payment-success/payment-success.component';
import { ModalRequestEmailComponent } from './modules/login/modal-request-email/modal-request-email.component';
import { NotificationComponent } from './modules/notification/notification.component';
import { PageNotFoundComponent } from './modules/page-not-found/page-not-found.component';
import { ModalShareMeasureComponent } from './modules/measure/modal-share-measure/modal-share-measure.component';
import { ModalSelectReportComponent } from './modules/measure/modal-select-report/modal-select-report.component';
import { ModalAccessOtherReportComponent } from './modules/measure/modal-access-other-report/modal-access-other-report.component';
import { ReportTopRankTemplateComponent } from './shared/components/report-top-rank-template/report-top-rank-template.component';
import { ReportTopRankComponent } from './shared/components/report-top-rank/report-top-rank.component';
import { ModalPermissionAccessMeasureComponent } from './modules/measure/modal-permission-access-measure/modal-permission-access-measure.component';
import { PrivateChatManagementComponent } from './modules/e-learning-management/private-chat-management/private-chat-management.component';
import { NgxImageCompressService } from "ngx-image-compress";
import { ELearningManagementTaComponent } from './modules/e-learning-management-ta/e-learning-management-ta.component';
import { CreateReceiptInvoiceComponent } from './modules/accounting/create-receipt-from-invoice/create-receipt-from-invoice.component';
import { PaymentManagementGovermentComponent } from './modules/payment-management/payment-management-goverment/payment-management-goverment.component';
import { PaymentManagementCompanyComponent } from './modules/payment-management/payment-management-company/payment-management-company.component';
import { ModalDetailInstallmentComponent } from './modules/accounting/modal-detail-installment/modal-detail-installment.component';
import { CreateQuotationComponent } from './modules/accounting/create-quotation/create-quotation.component';
import { ModalCancelComponent } from './modules/accounting/modal-cancel/modal-cancel.component';
import { ModalPrintComponent } from './modules/accounting/modal-print/modal-print.component';
import { CreateInvoiceComponent } from './modules/accounting/create-invoice/create-invoice.component';
import { CreatePersonalReceiptComponent } from './modules/accounting/create-personal-receipt/create-personal-receipt.component';
import { AccountingComponent } from './modules/accounting/accounting.component';
import { ModalCancelNoteComponent } from './modules/accounting/modal-Cancel-note/modal-Cancel-note.component';
import { PrintQuotationAgencyComponent } from './modules/accounting/print-quotation-agency/print-quotation-agency.component';
import { PrintQuotationOrganizationComponent } from './modules/accounting/print-quotation-organization/print-quotation-organization.component';
import { PrintInvoiceAgencyComponent } from './modules/accounting/print-invoice-agency/print-invoice-agency.component';
import { PrintInvoiceOrganizationComponent } from './modules/accounting/print-invoice-organization/print-invoice-organization.component';
import { PrintReceiptAgencyComponent } from './modules/accounting/print-receipt-agency/print-receipt-agency.component';
import { PrintReceiptOrganizationComponent } from './modules/accounting/print-receipt-organization/print-receipt-organization.component';
import { ModalInformantComponent } from './modules/measure/modal-informant/modal-informant.component';
import { ModalShareInformantComponent } from './modules/measure/modal-share-informant/modal-share-informant.component';
import { ProfileInformantComponent } from './modules/test-report-informant/profile-informant/profile-informant.component';
import { MatchingInformantComponent } from './modules/test-report-informant/matching-informant/matching-informant.component';
import { SpiderInformantComponent } from './modules/test-report-informant/spider-informant/spider-informant.component';
import { StandardInformantComponent } from './modules/test-report-informant/standard-informant/standard-informant.component';
import { BoxChartInformantComponent } from './modules/test-report-informant/box-chart-informant/box-chart-informant.component';
import { TopRankInformantComponent } from './modules/test-report-informant/top-rank-informant/top-rank-informant.component';
import { ModalCheckInformantComponent } from './modules/measure/modal-check-informant/modal-check-informant.component';
import { ModalAddQuestionInformantComponent } from './modules/measure-management/modal-add-question-informant/modal-add-question-informant.component';
import { QuestionInfMultipleChoiceComponent } from './shared/components/question-informant/question-inf-multiple-choice/question-inf-multiple-choice.component';
import { QuestionInfRatingComponent } from './shared/components/question-informant/question-inf-rating/question-inf-rating.component';
import { QuestionInfRankingComponent } from './shared/components/question-informant/question-inf-ranking/question-inf-ranking.component';
import { QuestionInfMostLeastComponent } from './shared/components/question-informant/question-inf-most-least/question-inf-most-least.component';
import { PaymentReceiptComponent } from './modules/payment-receipt/payment-receipt.component';
import { LearningCenterComponent } from './modules/learning-center/learning-center.component';
import { LearningCenterManagementComponent } from './modules/learning-center-management/learning-center-management.component';
import { ManageLearningCenterComponent } from './modules/learning-center-management/manage-learning-center/manage-learning-center.component';
import { LearningCenterUploadBannerComponent } from './modules/learning-center-management/manage-learning-center/learning-center-upload-banner/learning-center-upload-banner.component';
import { LearningCenterColorThemePickerComponent } from './modules/learning-center-management/manage-learning-center/learning-center-color-theme-picker/learning-center-color-theme-picker.component';
import { LearningCenterFirstSectionInputComponent } from './modules/learning-center-management/manage-learning-center/learning-center-first-section-input/learning-center-first-section-input.component';
import { LearningCenterProfileImageUploaderComponent } from './modules/learning-center-management/manage-learning-center/learning-center-profile-image-uploader/learning-center-profile-image-uploader.component';
import { LearningCenterSecondSectionInputComponent } from './modules/learning-center-management/manage-learning-center/learning-center-second-section-input/learning-center-second-section-input.component';
import { LearningCenterResearchSectionInputComponent } from './modules/learning-center-management/manage-learning-center/learning-center-research-section-input/learning-center-research-section-input.component';
import { LearningCenterVideoSectionUploaderComponent } from './modules/learning-center-management/manage-learning-center/learning-center-video-section-uploader/learning-center-video-section-uploader.component';
import { LearningCenterThirdSectionInputComponent } from './modules/learning-center-management/manage-learning-center/learning-center-third-section-input/learning-center-third-section-input.component';
import { VideoPlayerComponent } from './shared/components/video-player/video-player.component';
import { LearningCenterDetailComponent } from './modules/learning-center/learning-center-detail/learning-center-detail.component';
import { LearningCenterCardComponent } from './modules/learning-center/learning-center-card/learning-center-card.component';
import { LearningCenterContentComponent } from './modules/learning-center/learning-center-content/learning-center-content.component';
import { LearningCenterPreviewComponent } from './modules/learning-center-management/manage-learning-center/learning-center-preview/learning-center-preview.component';

const antDesignIcons = AllIcons as {
  [key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
  (key) => antDesignIcons[key]
);

export const MY_CUSTOM_FORMATS = {
  fullPickerInput: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  datePickerInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
  timePickerInput: { hour: 'numeric', minute: 'numeric' },
  monthYearLabel: { year: 'numeric', month: 'short' },
  dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
  monthYearA11yLabel: { year: 'numeric', month: 'long' },
};

const MaterialComponentModule = [
  MatInputModule,
  MatButtonModule,
  MatGridListModule,
  MatToolbarModule,
  MatIconModule,
  MatCardModule,
  MatCheckboxModule,
  MatRadioModule,
  MatDialogModule,
  MatChipsModule,
  MatAutocompleteModule,
  MatSelectModule,
  MatProgressSpinnerModule,
  MatSlideToggleModule,
  MatExpansionModule,
  MatTabsModule,
  MatSliderModule,
  MatBadgeModule
];

const NGBoootstrapComponentModule = [
  NgbModule,
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ProfileComponent,
    NavBarComponent,
    LoginComponent,
    RegisterComponent,
    BtnLifeDiComponent,
    ForgotPasswordComponent,
    ModalComponent,
    CardBoxComponent,
    DatePipe,
    DateTimePipe,
    DateTimeAgoPipe,
    IconHomeComponent,
    BreadcrumbComponent,
    ChipsComponent,
    UserManagementComponent,
    TableComponent,
    ModalAddAccountComponent,
    ModalAccountComponent,
    HistoryComponent,
    NewsUpdateComponent,
    ManageNewsComponent,
    ModalPreviewComponent,
    AllNewsComponent,
    NewsComponent,
    ActivityManagementComponent,
    ConsultComponent,
    WorkshopComponent,
    ManageWorkshopComponent,
    AllWorkshopComponent,
    WorkshopDetailComponent,
    ActivityComponent,
    LengthOfArrayPipe,
    ChangePasswordComponent,
    PhoneNOPipe,
    ModalConsultComponent,
    AddConsultComponent,
    ManageConsultComponent,
    DuplicateConsultComponent,
    ConsultUserComponent,
    RegisterConsultDialogComponent,
    AboutComponent,
    ELearningManagementComponent,
    ManageCourseComponent,
    ModalAddTopicComponent,
    ELearningComponent,
    CourseCardComponent,
    CourseComponent,
    ModalQuizComponent,
    ModalAssignmentComponent,
    AssignmentComponent,
    AssignmentManagementComponent,
    ReviewManagementComponent,
    ModalCertificateComponent,
    SanitizeHtmlPipe,
    UpgradePremiumComponent,
    ModalAvatarComponent,
    ArticalManagementComponent,
    ManageArticalComponent,
    ArticalsComponent,
    ModalArticalPreviewComponent,
    ModalArticalPollComponent,
    ArticalComponent,
    UserHistoryComponent,
    ChatManagementComponent,
    SearchComponent,
    SkillTreeComponent,
    SkillTreeManagementComponent,
    ManageSkillTreeComponent,
    ModalSkillTreeComponent,
    SymbolSkillTreeComponent,
    SkillTreeByCourseComponent,
    PrivacyPolicyComponent,
    FooterComponent,
    PaymentComponent,
    TransferComponent,
    PaymentManagementComponent,
    PaymentDetailComponent,
    PaymentVerifyComponent,
    ModalPaymentRejectComponent,
    MeasureManagementComponent,
    ManageMeasureComponent,
    ModalAddQuestionComponent,
    QuestionMultipleChoiceComponent,
    QuestionMultiComponent,
    QuestionRatingComponent,
    QuestionRankingComponent,
    QuestionMostLeastComponent,
    MultipleChoiceComponent,
    RatingChoiceComponent,
    RankingChoiceComponent,
    MostLeastChoiceComponent,
    MeasureComponent,
    MeasureManagementDetailComponent,
    MeasureStartComponent,
    MeasureCardComponent,
    ModalShareComponent,
    MeasureDetailComponent,
    SymbolRequireComponent,
    ModalMeasureReportComponent,
    ResearchComponent,
    ResearchScreenQuestionComponent,
    ResearchMeasureComponent,
    ResearchCardComponent,
    ResearchConsentComponent,
    ResearchDetailComponent,
    ResearchChoiceComponent,
    ModalMeasureReportConsultComponent,
    ResearchManagementComponent,
    ManageResearchComponent,
    ReportManagementComponent,
    ManageReportComponent,
    ModalCalculateComponent,
    ReportTemplateComponent,
    SymbolRequireComponent,
    TestReportComponent,
    ReportProfileComponent,
    ReportSpiderComponent,
    ReportStandardComponent,
    ReportBoxchartComponent,
    ReportMatchingComponent,
    ReportProfileTemplateComponent,
    ReportSpiderTemplateComponent,
    ReportFourBoxTemplateComponent,
    ReportProfileMatchingTemplateComponent,
    DashboardAdminComponent,
    FinancialListComponent,
    FinancialCategoryComponent,
    ModalPaymentReportComponent,
    ModalUploadSignatureComponent,
    PaymentSuccessComponent,
    ModalRequestEmailComponent,
    NotificationComponent,
    PageNotFoundComponent,
    ModalShareMeasureComponent,
    ModalSelectReportComponent,
    ModalAccessOtherReportComponent,
    ReportTopRankTemplateComponent,
    ReportTopRankComponent,
    ModalPermissionAccessMeasureComponent,
    PrivateChatManagementComponent,
    ELearningManagementTaComponent,
    PageNotFoundComponent,
    CreateReceiptInvoiceComponent,
    PaymentManagementGovermentComponent,
    PaymentManagementCompanyComponent,
    ModalDetailInstallmentComponent,
    CreateQuotationComponent,
    ModalCancelComponent,
    ModalPrintComponent,
    CreateInvoiceComponent,
    CreatePersonalReceiptComponent,
    AccountingComponent,
    ModalCancelNoteComponent,
    PrintQuotationAgencyComponent,
    PrintQuotationOrganizationComponent,
    PrintInvoiceAgencyComponent,
    PrintInvoiceOrganizationComponent,
    PrintReceiptAgencyComponent,
    PrintReceiptOrganizationComponent,
    ModalInformantComponent,
    ModalShareInformantComponent,
    ProfileInformantComponent,
    MatchingInformantComponent,
    SpiderInformantComponent,
    StandardInformantComponent,
    BoxChartInformantComponent,
    TopRankInformantComponent,
    ModalCheckInformantComponent,
    ModalAddQuestionInformantComponent,
    QuestionInfMultipleChoiceComponent,
    QuestionInfRatingComponent,
    QuestionInfRankingComponent,
    QuestionInfMostLeastComponent,
    PaymentReceiptComponent,
    LearningCenterComponent,
    LearningCenterManagementComponent,
    ManageLearningCenterComponent,
    LearningCenterUploadBannerComponent,
    LearningCenterColorThemePickerComponent,
    LearningCenterFirstSectionInputComponent,
    LearningCenterProfileImageUploaderComponent,
    LearningCenterSecondSectionInputComponent,
    LearningCenterResearchSectionInputComponent,
    LearningCenterVideoSectionUploaderComponent,
    LearningCenterThirdSectionInputComponent,
    VideoPlayerComponent,
    LearningCenterDetailComponent,
    LearningCenterCardComponent,
    LearningCenterContentComponent,
    LearningCenterPreviewComponent,
    
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialComponentModule,
    ReactiveFormsModule,
    HttpClientModule,
    SocialLoginModule,
    CarouselModule,
    NGBoootstrapComponentModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
    AngularEditorModule,
    FormsModule,
    MatDialogModule,
    TimepickerModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NzUploadModule,
    NzIconModule,
    NzButtonModule,
    NzSelectModule,
    NzAutocompleteModule,
    NzTableModule,
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ChartModule,
    NgxSliderModule,
    DragDropModule,
    NgxAudioPlayerModule,
    PlyrModule,
    NgxGraphModule,
    NgxChartsModule,
    MatTooltipModule,
    QRCodeModule,
    CountdownModule,
    NzBadgeModule,
    NzModalModule,
    NzImageModule,
    NzTabsModule,
    NzInputNumberModule,
    NzFormModule,
    NzInputModule,
    NzToolTipModule,
    NzDividerModule,
    NzMessageModule,
    NzCardModule,
    SwiperModule,
    NzSwitchModule,
    NzPopconfirmModule
  ],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('480791116698672')
          }
        ],
        onError: (err) => {
          console.error(err);
        },
      } as SocialAuthServiceConfig,
    },
    {
      provide: OWL_DATE_TIME_LOCALE,
      useValue: 'th',
      // useValue: MY_CUSTOM_FORMATS
    },
    { provide: NZ_ICONS, useValue: icons },
    { provide: NZ_I18N, useValue: en_US },
    CookieService,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS }, JwtHelperService,
    NgxImageCompressService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ModalComponent,
    ModalAddAccountComponent,
    ModalAccountComponent,
    ModalPreviewComponent,
    ModalAddTopicComponent,
  ],
})
export class AppModule { }
